<script>
import MetisMenu from "metismenujs/dist/metismenujs";

import Vue from "vue";
import {mapState} from "vuex";

/**
 * Sidenav component
 */
export default {
  data() {
    return {
      menuData: null,
      checkMounted: true,
      menu : [],
      isMounted: false,
    };
  },
  created() {
   //
    var currentUser = localStorage.getItem("auth-user");

    if (currentUser) {
      let data = JSON.parse(currentUser)
      if (data && data.menu)
        this.menu = data.menu;
    }
  },
  computed: {
    ...mapState('snackBarStore', ['isMenuAction'])
  },
  watch: {
    isMenuAction: {
      deep: true,
      handler() {
        if (this.isMounted) {
          this.handleMenuActive();
        }
      }
    },
    '$route.path': {
      handler() {
        if (this.isMounted) {
          this.handleMenuActive();
        }
      },
    },
  },
  mounted: function () {
    this.isMounted = true;
    var sideMenu = document.getElementById("side-menu");
    if (!sideMenu) {
      return;
    }

    new MetisMenu("#side-menu");
    this.handleMenuActive();
  },
  methods: {
    toggleCollapse(item) {
      item.collapsed = !item.collapsed;
    },
    clearMenuActive() {
      var sideMenu = document.getElementById("side-menu");
      if (!sideMenu) {
        return;
      }
      sideMenu.querySelectorAll(".active").forEach(el => el.classList.remove("active"));
      sideMenu.querySelectorAll(".mm-active").forEach(el => el.classList.remove("mm-active"));
      sideMenu.querySelectorAll(".mm-show").forEach(el => el.classList.remove("mm-show"));
    },
    handleMenuActive() {
      var sideMenu = document.getElementById("side-menu");
      if (!sideMenu) {
        // console.log("side-nav: sideMenu not found");
        return;
      }

      this.clearMenuActive();
      var currentMenu = localStorage.getItem("currentMenuId");
      // console.log("side-nav: currentMenu from localStorage:", currentMenu);

      var menuRef = new MetisMenu("#side-menu");
      var links = document.getElementsByClassName("side-nav-link-ref");
      // console.log("side-nav: found links:", links.length);

      var matchingMenuItem = null;
      const paths = [];
      for (var i = 0; i < links.length; i++) {
        const link = links[i].getAttribute("pathname");
        const menuId = links[i].getAttribute("menuId");
        paths.push({link: link, menuId: menuId});
      }
      // console.log("side-nav: paths array:", paths);

      var currentPath = window.location.pathname;
      // console.log("side-nav: currentPath:", currentPath);
      var itemIndex = paths.findIndex(x => x.link === currentPath && x.menuId == currentMenu);
      // console.log("side-nav: itemIndex after first find:", itemIndex);
      if (itemIndex === -1) {
        const strIndex = currentPath.lastIndexOf("/");
        // console.log("side-nav: strIndex:", strIndex);
        if (strIndex > 0) {
          const basePath = currentPath.substr(0, strIndex);
          // console.log("side-nav: basePath:", basePath);
          itemIndex = paths.findIndex(x => x.link === basePath && x.menuId == currentMenu);
          // console.log("side-nav: itemIndex after basePath find:", itemIndex);
          if (itemIndex === -1) {
            // Nếu không tìm được, chọn menu đầu tiên có link "/tin-noi-bo"
            itemIndex = paths.findIndex(x => x.link === "/tin-noi-bo");
            // console.log("side-nav: itemIndex for first /tin-noi-bo:", itemIndex);
            if (itemIndex !== -1) {
              // Cập nhật localStorage với menuId của menu đầu tiên
              localStorage.setItem("currentMenuId", paths[itemIndex].menuId);
              // console.log("side-nav: updated localStorage with menuId:", paths[itemIndex].menuId);
            }
          }
        } else if (currentPath === "/tin-noi-bo") {
          // Nếu currentPath là "/tin-noi-bo" và không có strIndex > 0, tìm menu đầu tiên
          itemIndex = paths.findIndex(x => x.link === "/tin-noi-bo");
          // console.log("side-nav: itemIndex for /tin-noi-bo direct:", itemIndex);
          if (itemIndex !== -1) {
            localStorage.setItem("currentMenuId", paths[itemIndex].menuId);
            // console.log("side-nav: updated localStorage with menuId:", paths[itemIndex].menuId);
          }
        }
      }
      // console.log("side-nav: final itemIndex:", itemIndex);
      if (itemIndex !== -1) {
        matchingMenuItem = links[itemIndex];
        // console.log("side-nav: matchingMenuItem set:", matchingMenuItem);
      } else {
        // console.log("side-nav: no matchingMenuItem found");
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        var parent = matchingMenuItem.parentElement;

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add("mm-active");
          const parent2 = parent.parentElement.closest("ul");
          if (parent2 && parent2.id !== "side-menu") {
            parent2.classList.add("mm-show");

            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add("mm-active");
              var childAnchor = parent3.querySelector(".has-arrow");
              var childDropdown = parent3.querySelector(".has-dropdown");
              if (childAnchor) childAnchor.classList.add("mm-active");
              if (childDropdown) childDropdown.classList.add("mm-active");

              const parent4 = parent3.parentElement;
              if (parent4 && parent4.id !== "side-menu") {
                parent4.classList.add("mm-show");
                const parent5 = parent4.parentElement;
                if (parent5 && parent5.id !== "side-menu") {
                  parent5.classList.add("mm-active");
                  const childanchor = parent5.querySelector(".is-parent");
                  if (childanchor && parent5.id !== "side-menu") {
                    childanchor.classList.add("mm-active");
                  }
                }
              }
            }
          }
        }
      }
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.children !== undefined ? item.children?.length > 0 : false;
    },
    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },
    handleGetIdMenu(path, id) {
      Vue.prototype.menuId = id;
      localStorage.setItem("currentMenuId", id);

      const targetPath = path === "/tin-noi-bo" ? `${path}/${id}` : path;
      if (targetPath !== window.location.pathname) {
        this.$router.push(targetPath).then(() => {
          this.handleMenuActive();
        }).catch(() => {});
      } else {
        this.handleMenuActive();
      }

      // // console.log("menu id:", targetPath);
    },
  },
};
</script>

<template>
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="item in menu">
        <li class="menu-title" v-if="item != null && item.isTitle" :key="item._id" style="color: #204b03">
          <i class="mdi mdi-star" aria-hidden="true"></i>
          {{item.name}}
          <i class="mdi mdi-star" aria-hidden="true"></i>
        </li>
        <template v-if="hasItems(item)">
          <li v-for="(value) in item.children" :key="value._id">
            <a :menuId="value._id" :pathname="value.link" style="cursor: pointer"
               class="side-nav-link-ref"
               @click="handleGetIdMenu(value.link, value._id)"
            >
              <i :class="`bx ${value.icon}`" v-if="value.icon" ></i>
              <span >{{ value.name}}</span>
<!--              <span :class="`badge rounded-pill bg-${value.badge.variant} float-end`"-->
<!--                    v-if="value.badge">{{ value.badge.text }} </span>-->
            </a>
          </li>
        </template>
      </template>
    </ul>
  </div>
</template>
<style type="text/css" scoped>
.mm-active > a {
  color: #000 !important;
}
#sidebar-menu ul li a:hover {
  color: #05912a;
}
.mm-active > a i {
  color: #000 !important;
}
#sidebar-menu > ul > li > a:hover i {
  color: #05912a;
}
#sidebar-menu ul li a:hover i {
  color: #05912a;
}
.side-nav-link-ref {
  padding-left: 35px !important;
}
.menu-title{
  font-size: 14px !important;
  color: #000;
}
</style>

